<template>
    <div class="figure-box">
        <Breadcrumb :crumb="crumb"></Breadcrumb>
        <div class="figure">
            <div class="left">
                <div class="item-box">
                    <div class="title flex align-center justify-between">
                        <span>个人信息</span>
                        <div class="flex align-center" @click="is_show_modal=true">
                            <img src="../../assets/images/design/choose@2x.png" style="width: 18px;"/>
                            <span style="margin-left: 5px;">选择客户</span>
                        </div>
                    </div>
                    <div class="input-item-box">
                        <div class="input-item">
                            <div class="name">姓名</div>
                            <input placeholder="请输入您的姓名" name="name" :value="form_data.profile.name"
                                   @input="update_profile($event)"/>
                        </div>
                        <div class="input-item">
                            <div class="name">性别</div>
                            <div class="radio-box" style="line-height: 42px;">
                                <RadioGroup name="sex" :value="form_data.profile.sex" @on-change="update_sex($event)">
                                    <Radio :label="1" :disabled="category.sex!=1">
                                        <span>男</span>
                                    </Radio>
                                    <Radio :label="2" :disabled="category.sex!=2">
                                        <span>女</span>
                                    </Radio>
                                </RadioGroup>
                            </div>
                        </div>
                        <div class="input-item">
                            <div class="name">生日</div>
                            <date-picker
                                    type="date"
                                    value-type="format"
                                    format="YYYY-MM-DD"
                                    :editable="false"
                                    :clearable="false"
                                    input-class="ub-input"
                                    @change="update_birthday"
                                    :value="form_data.profile.birthday"
                                    placeholder="请选择您的生日"
                            ></date-picker>
                        </div>
                    </div>
                    <div class="input-item-box">
                        <div class="input-item">
                            <div class="name">手机</div>
                            <input placeholder="请输入您的手机号" name="mobile" :value="form_data.profile.mobile"
                                   @input="update_profile($event)" @blur="blur($event)"/>
                        </div>
                        <div class="input-item">
                            <div class="name">身高</div>
                            <input placeholder="请输入您的身高（厘米）" name="height" :value="form_data.profile.height"
                                   @input="update_profile($event)"/>
                        </div>
                        <div class="input-item">
                            <div class="name">体重</div>
                            <input placeholder="请输入您的体重（公斤）" name="weight" :value="form_data.profile.weight"
                                   @input="update_profile($event)"/>
                        </div>
                    </div>
                    <div class="input-item-box">
                        <div class="input-item" style="margin-bottom: 10px;">
                            <div class="name">身体体型</div>
                            <Radio-group name="somatotype" :value="form_data.somatotype" style="margin-left:20px"
                                         @on-change="update_somatotype($event)">
                                <Radio :label="'Y'">
                                    <span>Y型&nbsp;&nbsp;&nbsp;</span>
                                </Radio>
                                <Radio :label="'A'">
                                    <span>A型&nbsp;&nbsp;&nbsp;</span>
                                </Radio>
                                <Radio :label="'B'">
                                    <span>B型&nbsp;&nbsp;&nbsp;</span>
                                </Radio>
                                <Radio :label="'C'">
                                    <span>C型&nbsp;&nbsp;&nbsp;</span>
                                </Radio>
                                <Radio :label="'D'">
                                    <span>D型&nbsp;&nbsp;&nbsp;</span>
                                </Radio>
                                <Radio :label="'E'">
                                    <span>E型&nbsp;&nbsp;&nbsp;</span>
                                </Radio>
                                <Radio :label="'T'">
                                    <span>T型&nbsp;&nbsp;&nbsp;</span>
                                </Radio>
                            </Radio-group>
                        </div>
                    </div>
                    <div class="input-item-box">
                        <div class="input-item" style="margin-bottom: 10px;">
                            <div class="name">穿衣偏好</div>
                            <Radio-group name="clothes_preference" :value="form_data.clothes_preference"
                                         style="margin-left:20px" @on-change="update_clothes_preference($event)">
                                <Radio :label="2">
                                    <span>紧身版</span>
                                </Radio>
                                <Radio :label="1">
                                    <span>合体版</span>
                                </Radio>
                                <Radio :label="4">
                                    <span>标准版</span>
                                </Radio>
                                <Radio :label="3">
                                    <span>宽松版</span>
                                </Radio>
                            </Radio-group>
                        </div>
                    </div>
                    <div class="input-item-box">
                        <div class="input-item" style="margin-bottom: 10px;">
                            <div class="name">量尺方式</div>
                            <Radio-group name="measure_type" :value="form_data.measure_type" style="margin-left:20px"
                                         @on-change="update_measure_type($event)">
                                <Radio :label="1" v-show="category.measure_type_string.length==0||category.measure_type_string.includes(1)">
                                    <span>净体量尺</span>
                                </Radio>
                                <Radio :label="3" v-show="category.measure_type_string.includes(3)">
                                    <span>套号量体</span>
                                </Radio>
                                <Radio :label="4" v-show="category.measure_type_string.includes(4)">
                                    <span>成衣量体</span>
                                </Radio>
                            </Radio-group>
                        </div>
                    </div>
                </div>

                <transition name="fade">
                    <div class="item-box" v-show="form_data.measure_type==1">
                        <div class="title">量体信息</div>
                        <div class="table-wrap">
                            <div class="input-box" v-for="(item, key) in net_param_list" :key="'netsize-'+key">
                                <div class="input-title">{{item.field_name_cn}}</div>
                                <Tooltip placement="top" :always="item.field_key in net_errors"
                                         :disabled="!(item.field_key in net_errors)" theme="light">
                                    <template v-slot:content>
                                        <p style="color:#BE0505">{{net_errors[item.field_key]}}</p>
                                    </template>
                                    <input
                                            class="input"
                                            type="text"
                                            :value="net_size[item.field_key]"
                                            @input="update_size($event, item.field_key, 'net_size')"
                                            placeholder="净"
                                    />
                                </Tooltip>
                            </div>
                            <div class="clear"></div>
                        </div>
                    </div>
                </transition>

                <transition name="fade">
                    <div class="item-box" v-show="form_data.measure_type==1 || form_data.measure_type==2">
                        <div class="title">成衣信息</div>
                        <div class="table-wrap">
                            <div class="input-box" v-for="(item, key) in complete_param_list" :key="'complete-size-'+key">
                                <div class="input-title">{{item.field_name_cn}}</div>
                                <Tooltip placement="top" :always="item.field_key in errors"
                                         :disabled="!(item.field_key in errors)" theme="light">
                                    <template v-slot:content>
                                        <p style="color:#BE0505">{{errors[item.field_key]}}</p>
                                    </template>
                                    <input
                                            class="input"
                                            type="text"
                                            :value="complete_size[item.field_key]"
                                            @input="update_size($event, item.field_key, 'complete_size')"
                                            placeholder=""
                                    />
                                </Tooltip>
                            </div>
                            <div class="clear"></div>
                        </div>
                    </div>
                </transition>

                <transition name="fade">
                    <div class="item-box" v-show="form_data.measure_type==3">
                        <div class="title">成衣部位</div>
                        <div style="margin: 20px 0">
                            <span>可选号型：</span>
                            <Select :value="form_data.ref_size" @on-change="change_taohao" style="width:200px">
                                <Option v-for="v in Object.keys(available_taohao_list)" :value="v" :key="v">{{ v }}</Option>
                            </Select>
                        </div>

                        <div class="complete-box">
                            <div class="complete-item" v-for="(item,index) in complete_param_list" :key="index">
                                <div class="main-name-wrap">
                                    <span style="margin-right:10px;cursor: pointer" @click="toggle_expand(item.field_key)">[{{expand_arr[item.field_key] ? '折叠':'展开'}}]</span>
                                    <span class="name">
                                        {{ item.field_name_cn }}<span class="ck">{{refer(item.field_key)}}</span>
                                    </span>

                                    <input
                                            class="input"
                                            type="text"
                                            :disabled="!allow_complete_list.includes(item.field_key)"
                                            :value="complete_size[item.field_key]"
                                            @input="update_size($event, item.field_key, 'complete_size')"
                                            placeholder=""
                                    />
                                    <span style="color:red;">{{hint(item.field_key)}}</span>
                                </div>
                                <div class="relate-item" v-show="expand_arr[item.field_key]" >
                                    <div class="relate-name-wrap" v-for="(vv, kk) in item.bxtz" :key="`bxtz`+kk">
                                        <span class="name">
                                            {{ vv.field_name_cn }}
                                        </span>
                                        <div class="img-list">
                                            <div class="img-box" @click="update_bxtz_feature(vv.field_key,vvv.text, vvv.val)"
                                                 v-for="(vvv,oindex) in vv.option_list" :key="`bb`+oindex"
                                                 :class="isActiveBxtz(vv.field_key,vvv.text) ? 'select-active':''">
                                                <div class="value"> {{ vvv.text }}</div>
                                            </div>
                                            <div class="clear"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>

                <transition name="fade">
                    <div class="item-box" v-show="form_data.measure_type==4">
                        <div class="title">成衣部位</div>
                        <div class="complete-box">
                            <div class="complete-item" v-for="(item,index) in c_complete_param_list" :key="index">
                                <div class="main-name-wrap">
                                    <span style="margin-right:10px;cursor: pointer" @click="toggle_expand(item.field_key)">[{{expand_arr[item.field_key] ? '折叠':'展开'}}]</span>
                                    <span class="name">
                                        {{ item.field_name_cn }}<span class="ck"></span>
                                    </span>

                                    <input
                                            class="input"
                                            type="text"
                                            :value="complete_size[item.field_key]"
                                            @input="update_size($event, item.field_key, 'complete_size')"
                                            placeholder=""
                                    />
                                </div>
                                <div class="relate-item" v-show="expand_arr[item.field_key]" >
                                    <div class="relate-name-wrap" v-for="(vv, kk) in item.txxz" :key="`txxz`+kk">
                                        <span class="name">
                                            {{ vv.field_name_cn }}
                                        </span>
                                        <div class="img-list">
                                            <div class="img-box" @click="update_txxz_feature(vv.field_key,vvv.text, vvv.val)"
                                                 v-for="(vvv,oindex) in vv.option_list" :key="`bb`+oindex"
                                                 :class="isActiveTxxz(vv.field_key,vvv.text) ? 'select-active':''">
                                                <div class="value"> {{ vvv.text }}</div>
                                            </div>
                                            <div class="clear"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>

                <div class="item-box">
                    <div class="title">体态特征</div>
                    <div class="body-box">
                        <div class="body-item" v-for="(item,index) in body_list" :key="index">
                            <div class="name">{{ item.field_name_cn }}</div>
                            <div class="img-list">
                                <div class="img-box" @click="update_body_feature(item.field_key,oitem.text)"
                                     v-for="(oitem,oindex) in item.option_list" :key="oindex"
                                     :class="isActiveBody(item.field_key,oitem.text) ? 'select-active':''">
                                    <img :src="oitem.image"/>
                                    <Icon type="ios-information-circle-outline" class="magnifier" size="20" @click.stop="mag(oitem.image)" />
                                    <div class="value"> {{ oitem.text }}</div>
                                </div>
                                <div class="clear"></div>
                            </div>
                        </div>
                        <div class="clear"></div>
                    </div>
                </div>

                <div class="item-box">
                    <div class="title">个人照片</div>
                    <div class="flex align-center" style="padding: 20px 0;">
                        <div class="upload-list">
                            <div class="profile-image-wrap" v-for="(item,index) in files" :key="'profile-img-' + index">
                                <Icon type="ios-close-circle" class="profile-image-icon" @click="remove_image(index)"/>
                                <img :src="item.url" style="width: 100px;height: 100px;"/>
                            </div>
                        </div>
                        <Upload ref="upload" :show-upload-list="false" :on-success="handleSuccess"
                                :format="['jpg','jpeg','png']" :max-size="2048" :on-format-error="handleFormatError"
                                :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" multiple
                                :action="uploadHost" :data="uploadData" style="display: inline-block;">
                            <img src="../../assets/images/design/add@2x.png" style="width: 100px;"/>

                        </Upload>
                    </div>

                </div>
                <div class="item-box">
                    <div class="title">个人备注</div>
                    <textarea name="remark" placeholder="请写上您的备注" :value="form_data.profile.remark"
                              @input="update_profile($event)"></textarea>
                </div>

                <div class="pay" @click="go2checkout">量体完成，提交订单</div>
            </div>
            <div class="right" v-show="true">
                <div class="title">订单确认</div>
                <div class="goods">
                    <img :src="this.$store.state.mtm.effect_picture || category.main_image"/>
                    <div class="content">
                        <div class="p-name">{{category.category_name_cn}}</div>
                        <div class="number-box">
                            <div class="minus">-</div>
                            <input class="num" v-model="num"/>
                            <div class="plus">+</div>
                        </div>
                    </div>
                </div>
                <div class="order">
                    <div class="main-color">成衣信息</div>
                    <div class="item" v-for="(item,index) in complete_param_list" :key="'complete-size-'+index">
                        <Tooltip placement="right" :always="item.field_key in errors"
                                 :disabled="!(item.field_key in errors)" theme="light">
                            <template v-slot:content>
                                <p style="color:#BE0505">{{errors[item.field_key]}}</p>
                            </template>
                            <span class="label">{{ item.field_name_cn }}</span>
                            <input
                                    class="input"
                                    type="text"
                                    :value="complete_size[item.field_key]"
                                    @input="update_size($event, item.field_key, 'complete_size')"
                                    placeholder=""
                            />cm
                        </Tooltip>

                    </div>
                    <div class="main-color">体态特征</div>
                    <div class="item" v-for="item in body_list" :key="'body-' + item.field_key">
                        <Tooltip placement="right" :always="item.field_key in errors"
                                 :disabled="!(item.field_key in errors)" theme="light">
                            <template v-slot:content>
                                <p style="color:#BE0505">{{errors[item.field_key]}}</p>
                            </template>
                            <span class="label">{{ item.field_name_cn }}</span>
                            <span class="value">{{ getBodyValue(item.field_key) || '未选择'}}</span>
                        </Tooltip>

                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </div>

        <CustomerList :is_show="is_show_modal" :list="customer_list" v-on:close-modal="close"
                      v-on:pop-customer="pop2form" v-on:search-customer="search"></CustomerList>
    </div>

</template>

<script>
    import {mapState} from 'vuex';
    import Breadcrumb from "@/components/Breadcrumb.vue";
    import {getFigureCustomers, checkFigureMobile, getFigureMeta, getBodyMeta, MFormulateCalculate, MTaohaoCalculate} from "@/api"
    import {oss} from '@/utils/aliyunoss.js'
    import CustomerList from "./components/CustomerList";
    import CalculatorManager from '@/utils/rule/Manager'
    import schema from 'async-validator'
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import 'vue2-datepicker/locale/zh-cn';

    export default {
        name: "Figure",
        components: {
            Breadcrumb,
            CustomerList,
            DatePicker
        },
        data() {
            return {
                available_taohao_list: {},
                available_hint_list: {},
                allow_complete_list: [],
                valid_hint_list: {},
                expand_arr: {},
                min_arr: {},
                max_arr: {},
                crumb: [{
                    title: "私人定制",
                    path: "Category",
                }],
                num: 1,
                is_show_modal: false,
                uploadHost: '',
                uploadData: {},
                customer_list: [],
                net_param_list: [],
                body_param_list: [],
                calculator: null,
                descriptor: {},
                validator: null,
                errors: {},
                net_errors: {},
            };
        },
        computed: {
            ...mapState({
                category: (state) => state.mtm.picked_category,
                complete_param_list: (state) => state.mtm.picked_category.figure,
                c_complete_param_list: (state) => state.mtm.picked_category.c_figure,
                body_list: (state) => state.mtm.picked_category.body,
                form_data: (state) => {
                    let {profile, clothes_preference, measure_type, somatotype, net_size, complete_size, body_feature,bxtz_feature,txxz_feature,ref_size} = state.mtm.form_data
                    return {
                        profile,
                        clothes_preference,
                        measure_type,
                        somatotype,
                        net_size,
                        complete_size,
                        body_feature,
                        bxtz_feature,
                        txxz_feature,
                        ref_size
                    }
                },
                net_size: (state) => {
                    return state.mtm.form_data.net_size
                },
                complete_size: (state) => {
                    return state.mtm.form_data.complete_size
                },
                body_feature: (state) => {
                    return state.mtm.form_data.body_feature
                },
                files: (state) => {
                    let images = Array.of();
                    state.mtm.form_data.profile.image.forEach((url) => {
                        images.push({
                            name: (new Date()).getTime(),
                            url
                        })
                    })
                    return images
                },
            }),
        },
        watch: {
            'form_data.profile.mobile': function (val, oldVal) {
                checkFigureMobile({
                    id: this.form_data.profile.id,
                    mobile: this.form_data.profile.mobile,
                }).then(response => {

                }).catch((err) => {
                    this.$Notice.error({
                        title: err.msg,
                        duration: 1,
                    })
                })
            },
            'form_data.profile.height': function (val, oldVal) {
                this.calculator.setHW(this.form_data.profile.height, this.form_data.profile.weight)
                this.update_somatotype(this.calculator.getDefaultSomatotype())
                this.update_category_size()
            },
            'form_data.profile.weight': function (val, oldVal) {
                this.calculator.setHW(this.form_data.profile.height, this.form_data.profile.weight)
                this.update_somatotype(this.calculator.getDefaultSomatotype())
                this.update_category_size()
            },
            'form_data.clothes_preference': function (val, oldVal) {
                this.update_category_size()
            },
            'form_data.somatotype': function (val, oldVal) {
                this.$store.commit('mtm/update_common', {key: 'ref_size', value: ''})
                this.getTaohaoList().finally(() => {
                    this.update_category_size()
                })
            },
            'form_data.measure_type': function (val, oldVal) {
                this.update_category_size()
            },
            net_size: {
                deep: true,
                handler: function (val, oldVal) {
                    this.calculator.setNetSize(val)
                    this.update_category_size()
                }
            },
            body_feature: {
                deep: true,
                handler: function (val, oldVal) {
                    this.calculator.setBodySize(val)
                    this.update_category_size()
                }
            },
        },
        mounted() {
            this.getTaohaoList()
            // 初始化验证器
            for (let key in this.complete_param_list) {
                this.descriptor[this.complete_param_list[key].field_key] = {
                    type: "number",
                    required: true,
                    message: `该参数未填写`,
                    transform(value) {
                        return parseFloat(value)
                    }
                }
                this.$set(this.expand_arr, this.complete_param_list[key].field_key, false)
            }
            for (let key in this.c_complete_param_list) {
                this.$set(this.expand_arr, this.c_complete_param_list[key].field_key, false)
            }
            for (let key in this.body_list) {
                this.descriptor[this.body_list[key].field_key] = {
                    type: "string",
                    required: true,
                    message: `该特征未选择`
                }
            }
            this.validator = new schema(this.descriptor);
            // this.validator.messages({
            // 	required: '%s 必填',
            // 	number: {
            // 		range: '范围值 %s %s-%s',
            // 	},
            // })

            // 初始化加放量计算器
            this.calculator = CalculatorManager.factory(this.category.style_no)

            getFigureCustomers({type:1, sex: this.category.sex}).then((response => {
                this.customer_list = response.data
            }))
            getFigureMeta().then((response) => {
                this.net_param_list = response.data
            })

            this.$emit('showLogin', true)
            this.$emit('showBack', true)
            this.$emit('showNav', false)
            this.$emit('showFooter', true)
        },
        methods: {
            refer(key) {
                let size = 0;
                size = this.available_taohao_list[this.form_data.ref_size] ? this.available_taohao_list[this.form_data.ref_size][key]: 0
                if(size) {
                    return `（参考尺寸：${size}）`
                }
                return ``
            },
            hint(key) {
                let regular = this.available_taohao_list?.[this.form_data.ref_size]?.[key]
                let min = this.valid_hint_list?.[key]?.min
                let max = this.valid_hint_list?.[key]?.max
                if(isNaN(min) && isNaN(max)) {
                    return ``
                }
                if((min==0) && (max==0)) {
                    return ``
                }

                let m1 = regular - (-1 * min)
                let m2 = regular - (-1 * max)
                return `（${m1.toFixed(1)}至${m2.toFixed(1)}）`;
            },
            async getTaohaoList() {
                return MTaohaoCalculate({...this.form_data, rule_soma: this.category.rule_soma}).then((response) => {
                    this.available_taohao_list = response.data.regular
                    this.available_hint_list = response.data.valid
                    this.allow_complete_list = response.data.allow_complete_list
                    return response
                })
            },
            change_taohao(e) {
                this.$store.commit('mtm/update_common', {key: 'ref_size', value: e})
                let complete_list = this.available_taohao_list[e]
                this.valid_hint_list = this.available_hint_list[e]
                for (let key in complete_list) {
                    this.update_size({
                        target: {
                            value: complete_list[key]
                        }
                    }, key, 'complete_size')
                }
            },
            mag(src) {
                this.$viewerApi({
                    options: {
                        title: false,
                        navbar: false,
                        movable: false,
                    },
                    images: [src],
                })
            },
            toggle_expand(key) {
                this.$set(this.expand_arr, key, !this.expand_arr[key])
            },
            blur(e) {
                if (!/^1[3|4|5|6|7|8]\d{9}$/.test(e.target.value)) {
                    this.$Notice.error({
                        title: "请输入正确的手机号",
                        duration: 1,
                    })
                }
            },
            update_profile(e) {
                this.$store.commit('mtm/update_profile', {
                    key: e.target.name,
                    value: e.target.value,
                })
            },
            update_birthday(date) {
                this.$store.commit('mtm/update_profile', {
                    key: 'birthday',
                    value: date,
                })
            },
            update_sex(e) {
                this.$store.commit('mtm/update_profile', {
                    key: 'sex',
                    value: e,
                })
            },
            update_clothes_preference(e) {
                this.calculator.setCustomSomatotype(this.form_data.somatotype)
                this.$store.commit('mtm/update_clothes_preference', e)
            },
            update_measure_type(e) {
                this.$store.commit('mtm/update_measure_type', e)
            },
            update_somatotype(e) {
                this.$store.commit('mtm/update_somatotype', e)
                this.calculator.setCustomSomatotype(e)
            },
            update_size(e, key, type_name) {
                this.calculator.setCustomSomatotype(this.form_data.somatotype)
                this.$store.commit('mtm/update_size', {
                    type_name,
                    key,
                    value: e.target.value
                })
                this.validate(false)
                if (type_name == 'net_size') {
                    let field = this.net_param_list.find((item) => {
                        return item.field_key === key
                    })
                    if(!field) return
                    if(e.target.value < field.valid_min || e.target.value > field.valid_max) {
                        this.$set(this.net_errors, field.field_key, `合理值范围${field.valid_min}cm~${field.valid_max}cm`)
                        setTimeout(() => {
                        delete this.net_errors[field.field_key]
                        this.$forceUpdate()
                        }, 3000)
                    }
                }
            },
            update_body_feature(name, desc) {
                this.calculator.setCustomSomatotype(this.form_data.somatotype)
                this.$store.commit('mtm/update_body_feature', {
                    body: name,
                    feature: desc
                })
                this.calculator.setBodySize({...this.form_data.body_feature, [name]: desc})
                this.validate(false)
            },
            update_bxtz_feature(name, desc, val) {
                this.$store.commit('mtm/update_bxtz_feature', {
                    key: name,
                    feature: desc,
                    val
                })
            },
            update_txxz_feature(name, desc, val) {
                this.$store.commit('mtm/update_txxz_feature', {
                    key: name,
                    feature: desc,
                    val
                })
            },
            close() {
                this.is_show_modal = false
            },
            search(filters) {
                getFigureCustomers({...filters, sex: this.category.sex}).then((response => {
                    this.customer_list = response.data
                }))
            },
            pop2form(selected_customer) {
                if(selected_customer.length > 1) {
                    if(selected_customer.length > 20) {
                        this.$Notice.error({
                            title: "批量下单限制20单"
                        })
                        return
                    }
                    this.$store.commit('mtm/set_profile_list', selected_customer)
                    this.$router.push({name: 'Checkout'})
                    this.is_show_modal = false
                } else {
                    this.$store.commit('mtm/set_profile_list', [])
                    let customer = selected_customer[0]
                    if (Object.keys(customer).length > 0) {
                        let {
                            clothes_preference,
                            measure_type,
                            figure_body,
                            image,
                            ...profile
                        } = customer;
                        for (let key in profile) {
                            this.update_profile({
                                target: {
                                    name: key,
                                    value: profile[key]
                                }
                            })
                        }
                        this.update_clothes_preference(clothes_preference)
                        this.$store.commit('mtm/update_measure_type', measure_type)
                        for (let key in figure_body.body_feature) {
                            this.update_body_feature(key, figure_body.body_feature[key])
                        }
                        this.$store.commit('mtm/reset_size', {type_name: 'net_size'})
                        for (let key in figure_body.net_size) {
                            this.update_size({
                                target: {
                                    value: figure_body.net_size[key]
                                }
                            }, key, 'net_size')
                        }

                        this.$store.commit('mtm/clear_profile_image')
                        image.forEach((url) => {
                            this.$store.commit('mtm/add_profile_image', url)
                        })
                    }
                    this.is_show_modal = false
                }
            },
            getBodyValue(key) {
                return this.form_data.body_feature[key]
            },
            isActiveBody(field_key, text) {
                if (this.form_data.body_feature[field_key] == text) {
                    return true
                }
                return false
            },
            getBxtzValue(key) {
                return this.form_data.bxtz_feature[key]
            },
            isActiveBxtz(field_key, text) {
                if (this.form_data.bxtz_feature[field_key] == text) {
                    return true
                }
                return false
            },
            getTxxzValue(key) {
                return this.form_data.txxz_feature[key]
            },
            isActiveTxxz(field_key, text) {
                if (this.form_data.txxz_feature[field_key] == text) {
                    return true
                }
                return false
            },
            remove_image(index) {
                this.$store.commit('mtm/remove_profile_image', index)
            },
            handleSuccess(res, file) {
                this.$store.commit('mtm/add_profile_image', this.uploadData.oss_url + this.uploadData.dir + file.name)
            },
            handleFormatError(file) {
                this.$Notice.warning({
                    title: '文件格式不正确',
                    desc: '文件 ' + file.name + ' 格式不正确，请上传 jpg 或 png 格式的图片。'
                });
            },
            handleMaxSize(file) {
                this.$Notice.warning({
                    title: '超出文件大小限制',
                    desc: '文件 ' + file.name + ' 太大，不能超过 2M。'
                });
            },
            handleBeforeUpload(file) {
                //console.log(file,"file.name")
                return oss(file.name).then(res => {
                    this.uploadHost = res.host
                    this.uploadData = res
                })
            },
            validate(is_submit) {
                this.validator.validate({...this.complete_size, ...this.body_feature}, {
                    first: false,
                    firstFields: true
                }, (errors, fields) => {
                    this.errors = {}
                    console.log(this.errors)
                    if (errors) {
                        for (let [key, err] of Object.entries(fields)) {
                            // console.log(key, err)
                            this.$set(this.errors, key, err[0].message)
                        }
                        // return
                    }

                    if (is_submit) {
                        this.$router.push({name: 'Checkout'})
                    }
                    // validation passed
                })
            },
            go2checkout() {
                if(!this.form_data.profile.name || !this.form_data.profile.mobile || !this.form_data.profile.weight || !this.form_data.profile.height) {
                    this.$Notice.error({
                        title: "请完善客户信息",
                        duration: 1,
                    })
                    return
                }
                if(this.form_data.measure_type == 1) {
                    for(let i in this.net_param_list) {
                        if(!(this.net_param_list[i]['field_key'] in this.net_size) || (String(this.net_size[this.net_param_list[i]['field_key']])).length === 0 ) {
                            // this.$Notice.error({
                            //     title: `${this.net_param_list[i]['field_name_cn']}未填写`,
                            //     duration: 1,
                            // })
                            // return
                        }
                    }
                }
                this.validate(true)
            },
            // 因身高/体重/穿衣偏好/体型选择变动导致的成衣尺寸重新计算
            update_category_size() {
                let promise = new Promise(async (resolve, reject) => {
                    // 默认全部都是0
                    this.calculator.setHW(this.form_data.profile.height, this.form_data.profile.weight)
                    this.calculator.setNetSize(this.form_data.net_size)
                    let complete_list = this.calculator.getCompleteSize(String(this.form_data.clothes_preference))
                    let body_list = this.calculator.getBodySize()
                    if(this.form_data.measure_type==2 || this.form_data.measure_type==3 || this.form_data.measure_type==4) {
                        this.$Spin.show();
                        body_list = complete_list = []
                    } else if(this.category.rule_type == 1) {
                        this.$Spin.show();
                        let result = await MFormulateCalculate({...this.form_data, rule_id: this.category.rule_id}).catch(err => {
                            reject(err)
                        })
                        if(result.code > 0) {

                        } else {
                            complete_list = result.data.complete_size
                            body_list = result.data.body_size
                        }
                    }
                    for (let key in complete_list) {
                        this.update_size({
                            target: {
                                value: complete_list[key]
                            }
                        }, key, 'complete_size')
                    }
                    for (let key in body_list) {
                        this.$store.commit('mtm/update_size', {
                            type_name: 'body_size',
                            key,
                            value: body_list[key]
                        })
                    }
                    resolve()
                }).catch((err) => {
                    this.$Spin.hide()
                }).finally(() => {
                    this.$Spin.hide()
                })

            },
        },
    };
</script>

<style scoped lang="scss">
    .figure-box {
        width: 1170px;
        margin: 20px auto;
    }

    .figure {
        margin-top: 20px;
        margin-bottom: 50px;
    }

    .left {

        .item-box {
            background: #ffffff;
            box-shadow: 0px 2px 23px rgba(0, 0, 0, 0.07);
            border-radius: 5px;
            padding: 0 20px;
            margin-bottom: 20px;

            .complete-box {
                margin: 20px 0;

                .complete-item {
                    margin-bottom: 10px;
                    border-bottom: 1px dashed #777;
                    .main-name-wrap {
                        width: 800px;
                        font-size: 14px;
                        font-weight: bold;
                        line-height: 59px;

                        .name {
                            display: inline-block;
                            width: 200px;
                        }
                        .ck {
                            font-size: 12px;
                            color: black;
                        }
                        .input {
                            width: 80px;
                            height: 30px;
                            line-height: 30px;
                            background: #FFFFFF;
                            margin-left: 10px;
                            text-align: center;
                        }
                    }

                    .relate-item {
                        margin-bottom: 10px;
                        .relate-name-wrap {
                            display: flex;
                            align-items: center;
                            .name {
                                width: 90px;
                                font-size: 14px;
                                font-weight: bold;
                            }

                            .img-list {
                                display: flex;
                                flex-wrap: wrap;
                                justify-content: left;
                                .img-box {
                                    text-align: center;
                                    margin: 10px;
                                    padding: 8px 24px;
                                    cursor: pointer;
                                    border: 1px solid #ccc;
                                    border-radius: 8px;
                                    img {
                                        width: 160px;
                                        height: 160px;
                                        border-radius: 20px;
                                        border: 2px solid #ccc;
                                        object-fit: contain;
                                    }

                                    .value {
                                        font-size: 12px;
                                        font-weight: 400;
                                        color: #000000;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .body-box {
                margin: 20px 0;

                .body-item {
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                    border-bottom: 1px dashed #777;

                    .name {
                        width: 90px;
                        font-size: 14px;
                        font-weight: bold;
                        line-height: 59px;
                    }

                    .img-list {
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: left;
                        .img-box {
                            text-align: center;
                            margin: 6px;
                            position: relative;
                            img {
                                width: 160px;
                                height: 160px;
                                border-radius: 20px;
                                border: 2px solid #ccc;
                                object-fit: contain;
                            }
                            .magnifier{
                                position: absolute;
                                bottom:35px;
                                right:5px;
                            }
                            .value {
                                font-size: 12px;
                                font-weight: 400;
                                color: #000000;
                            }
                        }
                    }
                }
            }

            textarea {
                height: 80px;
                background: #F3F4F5;
                opacity: 1;
                border-radius: 5px;
                padding: 10px;
                width: 100%;
                border: none;
                margin: 20px 0;
            }

            .title {
                height: 52px;
                line-height: 52px;
                border-bottom: 1px solid #e9e9e9;
                color: #0f114a;
                font-size: 16px;
                font-weight: bold;
            }

            .input-item-box {
                margin-top: 20px;
                display: flex;
                height: 42px;

                .input-item {
                    display: flex;
                    align-items: center;
                }

                .name {
                    font-size: 15px;
                    font-weight: bold;
                    color: #000000;
                    min-width: 30px;
                }

                .radio-box,
                ::v-deep .ub-input,
                input {
                    width: 214px;
                    height: 42px;
                    border-bottom: 1px solid #dddddd;
                    border-top: none;
                    border-left: none;
                    border-right: none;
                    margin: 0 20px;
                    padding-left: 10px;
                }
            }
        }

        .pay {
            width: 360px;
            height: 44px;
            line-height: 44px;
            margin: 0 auto;
            background: #0f114a;
            opacity: 1;
            border-radius: 2px;
            text-align: center;
            font-size: 16px;
            font-weight: bold;
            color: #edd4ac;
            cursor: pointer;
        }
    }

    .right {
        margin-left: 30px;
        width: 270px;
        background: #ffffff;
        box-shadow: 0px 2px 23px rgba(0, 0, 0, 0.07);
        padding: 0 20px;
        position: fixed;
        top: 100px;
        right: 50px;

        .title {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: bold;
            line-height: 22px;
            color: #000000;
            height: 52px;
            line-height: 52px;
            border-bottom: 1px solid #e9e9e9;
            text-align: center;
        }

        .goods {
            padding-top: 10px;
            display: flex;

            img {
                width: 80px;
                height: 80px;
            }

            .content {
                margin-left: 10px;

                .p-name {
                    font-size: 15px;
                    font-weight: bold;
                    color: #000000;
                    height: 60px;
                }

                .number-box {
                    height: 20px;
                    border: 1px solid #999999;
                    display: flex;
                    align-items: center;

                    .minus,
                    .plus {
                        width: 27px;
                        cursor: pointer;
                        color: #707070;
                        line-height: 27px;
                        text-align: center;
                        font-size: 18px;
                    }

                    .num {
                        border-top: none;
                        border-bottom: none;
                        border-left: 1px solid #999999;
                        border-right: 1px solid #999999;
                        width: 27px;
                        text-align: center;
                        color: #000000;
                    }
                }
            }
        }

        .order {
            padding-bottom: 10px;

            .main-color {
                font-size: 16px;
                font-weight: bold;
                color: #0f114a;
                margin: 20px 0 10px;
            }

            .item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 1px solid #dddddd;
                height: 44px;

                ::v-deep .ivu-tooltip-rel {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 44px;
                    width: 230px;
                }

                span.label {
                    width: 60px;
                    font-size: 13px;
                    font-weight: bold;
                    color: #333333;
                    text-align: right;
                }

                .value {
                    font-weight: 400;
                    color: #666666;
                }

                .input {
                    width: 80px;
                    height: 30px;
                    line-height: 30px;
                    background: #FFFFFF;
                    margin-left: 10px;
                    text-align: center;
                }
            }
        }

        .total {
            height: 44px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            span {
                font-size: 15px;
                font-weight: bold;
                color: #333333;
            }

            .price {
                font-weight: 400;
                color: #0f114a;
            }
        }

    }

    .select-active {
        position: relative;
    }

    .select-active:after {
        background-image: url("../../assets/images/design/select@2x.png");
        background-size: 100%;
        width: 13px;
        height: 13px;
        position: absolute;
        right: 5px;
        top: 5px;
        content: "";
    }

    .table-wrap {
        display: flex;
        flex-wrap: wrap;
        justify-content: left;
        align-items: center;

        .input-box {
            display: flex;
            justify-content: left;
            align-items: center;
            width: 180px;
            height: 60px;

            ::v-deep .ivu-tooltip-rel {
                height: 30px;
                width: 80px;
            }

            .input-title {
                width: 100px;
                font-size: 14px;
                font-weight: bold;
                color: #000000;
                text-align: right;
            }

            .input {
                width: 80px;
                height: 30px;
                line-height: 30px;
                background: #FFFFFF;
                margin-left: 10px;
                text-align: center;
            }
        }
    }

    .upload-list {
        display: inline-block;
        margin-right: 10px;

        .profile-image-wrap {
            display: inline-block;
            position: relative;

            .profile-image-icon {
                position: absolute;
                top: -10px;
                right: 0;
                font-size: 20px;
                z-index: 100;
            }
        }

        img {
            margin: 0 10px;
        }
    }

</style>
